import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { axios } from '../../services/ServiceUtils';
import { withRouter } from 'react-router-dom';
import { FaqPageBlock, SearchBlock, BackButton, FaqPageCategories } from './style';
import Title from '../../components/Title';
import { Category } from './components/Category';
import { SearchForm } from './components/SearchForm';
import { QuestionsList } from './components/QuestionsList';
import { FaqProvider } from '../../contexts/FAQContext';
import { SearchList } from './components/SearchList';
import ErrorPage from '../ErrorPage';
import LanguageContext from '../../contexts/LanguageContext';

const FAQ = props => {
  const [error, setError] = useState(false);
  const {
    match: {
      params: { category, term, questionCategory = null },
    },
  } = props;

  const [faqContent, setfaqContent] = useState({
    title: '',
    subTitle: '',
    searchInput: {},
    modules: [],
    dfsAccountTypes: { dfsAccountTypes: [] },
  });

  const selectedCategory = faqContent.modules.find(cat => cat.key === `faq-${category}`);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    document.title="DFS | FAQ"
    axios
      .get(`api/faq-header`, {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(result => {
        if (!result.data || !result.data.title) setError(true);
        // if(result.data.modules.length === 1){
        //   history.push(`/faq/${result.data.modules[0].key}`);
        // }
        setfaqContent(result.data);
      })
      .catch(e => {
        setError(true);
        // eslint-disable-next-line
        console.error('request error', e);
      });
  }, [language]);

  return error ? (
    <ErrorPage />
  ) : (
    <Container className="container-fluid container-xl p-0">
      <FaqPageBlock category={category}>
        <FaqPageCategories category={category}>
          <Row className="mx-2">
            <Col xs="12" className="px-lg-0 mx-lg-0 pb-lg-3 pl-2 ml-0 pl-lg-2">
              <Title>{faqContent.title}</Title>
            </Col>
          </Row>
          <Row className="mx-2 mb-3" role="tablist">
            <Col xs="12" className="px-0 mx-2 mb-1">
              <div>{faqContent.subTitle}</div>
            </Col>
            {faqContent.modules
              ? faqContent.modules
                  .sort((a, b) => a.order - b.order)
                  .map(cat => <Category key={cat.key} data={cat} />)
              : null}
          </Row>
        </FaqPageCategories>
        {category ? (
          <SearchBlock 
            id={`content-${selectedCategory?.key}`} 
            role="tabpanel" 
            aria-labelledby={selectedCategory?.key}
          >
            <BackButton className="d-flex align-items-center d-lg-none" to="/faq">
              <span className="dds__icons dds__chevron-left" />
              Back to all FAQ categories
            </BackButton>
            <FaqProvider
              category={category}
              faqContent={faqContent}
              term={term || ''}
              questionCategory={questionCategory}
            >
              <Row className="mx-0 px-3">
                <Col xs="12" className="p-0">
                  <SearchForm labels={faqContent.searchInput} />
                </Col>
              </Row>
              <Row className="mx-0 px-3">
                <Col xs="12">{term ? <SearchList category={category} /> : <QuestionsList />}</Col>
              </Row>
            </FaqProvider>
          </SearchBlock>
        ) : (
          ''
        )}
      </FaqPageBlock>
    </Container>
  );
};

export default withRouter(FAQ);
